export default async function sleep(ms = 1000) {
  const result = new Promise((resolve) => setTimeout(resolve, ms))
  await result
}
